/**
 * Re-init Reviews.io snippets inside the sticky ATC bar after variant changes.
 */
(() => {
  const RATING_CONFIG = {
    store: "kitchenland-shop.myshopify.com",
    mode: "default",
    color: "#f6dc22",
    linebreak: false,
    lang: "de",
    usePolaris: false,
    showEmptyStars: false,
    showNumericalAverageRating: false,
  };

  const refreshStickyReviews = () => {
    if (typeof ratingSnippet !== "function") {
      return;
    }
    if (!document.querySelector(".em-sticky-atc .ruk_rating_snippet")) {
      return;
    }
    ratingSnippet("ruk_rating_snippet", RATING_CONFIG);
  };

  const observeStickyBar = () => {
    document.querySelectorAll('product-rerender[id$="-sticky-bar"]').forEach((node) => {
      new MutationObserver(() => {
        refreshStickyReviews();
      }).observe(node, { childList: true, subtree: true });
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      refreshStickyReviews();
      observeStickyBar();
    }, { once: true });
  } else {
    refreshStickyReviews();
    observeStickyBar();
  }

  document.addEventListener("shopify:section:load", refreshStickyReviews);
})();
